import errorsHandler from '@/services/errors-handler'
import { getStateCallbacks, getStateProviders } from '@/store'

import { microfrontends } from '@/config/microfrontends'
import { analytics } from '@/services/analyticsProvider'
import { LanguageStorage } from '@/services/LanguageStorage'
import {
  ICookieConsent,
  ICookieFunctions,
  ICookieData,
} from '@sennder/microfrontend-registry/Cookie'

const DEFAULT_CONSENT: ICookieConsent = {
  ESSENTIAL: true,
  ANALYTICS: false,
}

const cookieModule = microfrontends.cookies

let cookieFunctions: ICookieFunctions

async function loadCookieFunctions() {
  if (!cookieFunctions) {
    cookieFunctions = await cookieModule.getModule<ICookieFunctions>(
      './cookiemfcomponentApp'
    )
  }
}

async function getCookieData(): Promise<ICookieData> {
  const storedLang = LanguageStorage.get()

  const modalLanguage = storedLang
    ? storedLang
    : // use language from browser by default, because profile is not loaded yet
      navigator.language.split('-')[0] || 'en'

  return {
    language: modalLanguage,
    logger: getStateProviders().logger,
    onUnhandledError: getStateCallbacks().onUnhandledError,
  }
}

export async function getCookieConsent() {
  try {
    await loadCookieFunctions()
    return await cookieFunctions.getCookieConsent(await getCookieData())
  } catch (error) {
    errorsHandler(error)
    return DEFAULT_CONSENT
  }
}

export async function promptCookieConsent() {
  try {
    await loadCookieFunctions()
    const consent = await cookieFunctions.promptCookieConsent(
      await getCookieData()
    )

    if (consent.ANALYTICS) {
      analytics.trackEvent('cookie_preferences', {
        essential: consent.ESSENTIAL,
        analytics: consent.ANALYTICS,
      })
    }

    return consent
  } catch (error) {
    errorsHandler(error)
    return DEFAULT_CONSENT
  }
}
